import { Zap } from 'lucide-react';

import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';

import { colors } from 'constants/colors';

// A site can now carry two deliveries/rangements the same day: a fixed one and a dynamic one.
// This flags ONLY the dynamic one with a discreet icon — fixed items stay unchanged (renders null).
// Hovering reveals what it means, so the icon can stay compact and text-free.
// `size` (px) lets dense views (calendar events, timeline rail) render a smaller icon.
export const DynamicDeliveryTag = ({
    isDynamic,
    label = 'Dynamique',
    size = 16,
}: {
    isDynamic?: boolean;
    label?: string;
    size?: number;
}) => {
    if (!isDynamic) {
        return null;
    }

    return (
        <TooltipProvider>
            <Tooltip>
                <TooltipTrigger asChild>
                    <span
                        className="inline-flex shrink-0 items-center justify-center"
                        style={{ color: colors.violet, width: size, height: size }}
                        aria-label={label}
                    >
                        <Zap size={size} fill={colors.violet} strokeWidth={0} />
                    </span>
                </TooltipTrigger>
                <TooltipContent>{label}</TooltipContent>
            </Tooltip>
        </TooltipProvider>
    );
};
